import styled from '@emotion/styled';

const Header = styled.div<{ hideOnMobile: boolean }>`
  height: 90px;
  text-align: center;
  background-color: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-family: inherit;
  font-weight: 400;
  @media (max-width: 768px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'flex')};
  }
`;

const HeaderLogo = styled.img`
  max-height: 60px;
  max-width: 100%;
  object-fit: contain;
`;

type PartnerHeaderProps = {
  bgColor?: string;
  title: string;
  logo?: string;
  isLiveHeader?: boolean;
  hideOnMobile?: boolean;
};

export const PartnerHeader = ({
  bgColor = '#333',
  title,
  logo,
  isLiveHeader = false,
  hideOnMobile = false,
}: PartnerHeaderProps) => {
  const bgStyle = { backgroundColor: bgColor };
  const shouldHideOnMobile = hideOnMobile && !isLiveHeader;

  return (
    <Header hideOnMobile={shouldHideOnMobile} style={bgStyle}>
      {logo ? <HeaderLogo src={logo} alt={title} /> : title}
    </Header>
  );
};
